import { createReducer, on } from '@ngrx/store';
import * as SidebarActions from './sidebar.actions';

export type SidebarMode = 'expanded' | 'collapsed';

export interface SidebarState {
   /**
    * Canonical sidebar state
    */
   mode: SidebarMode;

   /**
    * Backward compatibility flag
    * DO NOT remove until all consumers migrate
    */
   isExpanded: boolean;
}

/**
 * IMPORTANT:
 * - No window
 * - No localStorage
 * - No breakpoint logic
 * - Deterministic initial state (SSR-safe)
 */
export const initialState: SidebarState = {
   mode: 'collapsed',
   isExpanded: false
};

export const sidebarReducer = createReducer(
   initialState,

   /** Toggle only makes sense when sidebar is visible */
   on(SidebarActions.toggleSidebar, (state) => {
      const nextMode: SidebarMode =
         state.mode === 'expanded' ? 'collapsed' : 'expanded';

      return {
         ...state,
         mode: nextMode,
         isExpanded: nextMode === 'expanded'
      };
   }),

   on(SidebarActions.expandSidebar, (state) => ({
      ...state,
      mode: 'expanded' as SidebarMode,
      isExpanded: true
   })),

   on(SidebarActions.collapseSidebar, (state) => ({
      ...state,
      mode: 'collapsed' as SidebarMode,
      isExpanded: false
   }))
);
